var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftSso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H2v9h9V2z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H2v9h9v-9z",
    fill: "#00A4EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2h-9v9h9V2z",
    fill: "#7FBA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13h-9v9h9v-9z",
    fill: "#FFB900"
  })));
}

export default "data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M11 2H2v9h9V2z' fill='%23F25022'/%3E%3Cpath d='M11 13H2v9h9v-9z' fill='%2300A4EF'/%3E%3Cpath d='M22 2h-9v9h9V2z' fill='%237FBA00'/%3E%3Cpath d='M22 13h-9v9h9v-9z' fill='%23FFB900'/%3E%3C/svg%3E";
export { SvgMicrosoftSso as ReactComponent };